import Button, { ButtonProps } from "../button";
import { CheckOutlined } from "@ant-design/icons";
import { useTranslations } from "use-intl";

export function AcceptButton({ children, ...props }: ButtonProps) {
  const t = useTranslations("Common");

  return (
    <Button icon={<CheckOutlined />} success {...props}>
      {children ?? t("Accept")}
    </Button>
  );
}
